const cache = new Map()

export function loadImage(src, onLoad) {
    if (!src) return

    if (cache.has(src)) {
        onLoad(cache.get(src))
        return
    }

    const img = new Image()
    if (src.startsWith('data:') || src.startsWith('blob:')) {
        img.crossOrigin = ''
    } else {
        img.crossOrigin = 'anonymous'
    }
    img.onload = () => {
        cache.set(src, img)
        onLoad(img)
    }
    img.onerror = () => {
        console.warn('Failed to load image:', src)
    }
    img.src = src
}
